import { render } from "./FeatureStage.vue?vue&type=template&id=0c6dc75b&scoped=true"
import script from "./FeatureStage.vue?vue&type=script&lang=js"
export * from "./FeatureStage.vue?vue&type=script&lang=js"

import "./FeatureStage.vue?vue&type=style&index=0&id=0c6dc75b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6dc75b"]])

export default __exports__